
export enum LabelPosition {
  Inner = 'inner',
  Outer = 'outer'
}

export enum LabelAlignment {
    None = 'none',
    LabelLine = 'labelLine',
    Edge = 'edge'
}

